import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { serviceAccountsApiRef } from '../plugin';
import { DeleteServiceAccountRequest } from '@agilelab/plugin-wb-service-accounts-common';
import { QUERY_KEY_SERVICE_ACCOUNTS } from '../constants';

export const useDeleteServiceAccount = () => {
  const serviceAccountsApi = useApi(serviceAccountsApiRef);
  const alertApi = useApi(customAlertApiRef);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: DeleteServiceAccountRequest) => {
      return serviceAccountsApi.deleteServiceAccounts(request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SERVICE_ACCOUNTS],
      });
      alertApi.post({
        severity: 'success',
        message: 'Service account deleted successfully',
      });
    },
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
